import detail from './detail';
import list from './list';

export default {
  detail,
  list,
};
